import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Collection_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";


function Collection_Report() {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  // State for Date Filters
  const [startDate, setStartDate] = useState("2025-11-27");
  const [endDate, setEndDate] = useState("2026-02-02");
  const [mode, setMode] = useState("");

  // Grade filter state
  const [grades, setGrades] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState("");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        start_date: startDate,
        end_date: endDate,
        transaction_mode: mode,
        class_id: selectedGrade,
      };

      const response = await simplePostCall(
        ApiConfig.collection1Report,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setReportData(response.searchModel || []);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, mode, selectedGrade]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const fetchGrades = useCallback(async () => {
    try {
      const res = await simplePostCall(ApiConfig.classlist, JSON.stringify({
        customer_id: Number(localStorage.getItem("customer_id")),
        api_key: localStorage.getItem("api_key"),
      }));
      if (res?.classread) setGrades(res.classread);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchGrades();
  }, [fetchGrades]);

  const handleClearFilters = () => {
    setStartDate("");
    setEndDate("");
    setMode('');
    setSelectedGrade('');
  };
  return (
    <div
      className="cashless_balance_report-container"
      style={{ paddingTop: "25px" }}
    >
      {/* Header Section */}
      <div className="cashless_balance_report-row">
        <div className="cashless_balance_report-col">
          <div className="cashless_balance_report-panel">
            <div className="cashless_balance_report-panel-body">
              <div className="cashless_balance_report-header">
                <h3 className="cashless_balance_report-title">
                  Collection Report
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filter and Table Section */}
      <div className="cashless_balance_report-row">
        <div className="cashless_balance_report-col">
          <div className="cashless_balance_report-panel">
            <div className="cashless_balance_report-panel-body">

              {/* Filter Bar */}
              <div style={{ display: "flex", gap: "12px", alignItems: "flex-end", flexWrap: "wrap", marginBottom: "18px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <label style={{ fontSize: "12px", fontWeight: 600, color: "#555" }}>Grade</label>
                  <select
                    value={selectedGrade}
                    onChange={(e) => setSelectedGrade(e.target.value)}
                    style={{ height: "36px", padding: "0 8px", borderRadius: "4px", border: "1px solid #ced4da", minWidth: "140px", fontSize: "14px" }}
                  >
                    <option value="">All Grades</option>
                    {grades.map((grade) => (
                      <option key={grade.class_id} value={grade.class_id}>
                        {grade.class_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <label style={{ fontSize: "12px", fontWeight: 600, color: "#555" }}>Payment Mode</label>
                  <select
                    value={mode}
                    onChange={(e) => setMode(e.target.value)}
                    style={{ height: "36px", padding: "0 8px", borderRadius: "4px", border: "1px solid #ced4da", minWidth: "140px", fontSize: "14px" }}
                  >
                    <option value="">All Modes</option>
                    <option value="by cash">By Cash</option>
                    <option value="cheque">Cheque</option>
                    <option value="dd">DD</option>
                    <option value="bank transfer">Bank Transfer</option>
                    <option value="mpesa_manual">Mpesa</option>
                    <option value="wallet">Wallet</option>
                  </select>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <label style={{ fontSize: "12px", fontWeight: 600, color: "#555" }}>From Date</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    style={{ height: "36px", padding: "0 8px", borderRadius: "4px", border: "1px solid #ced4da", fontSize: "14px" }}
                  />
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  <label style={{ fontSize: "12px", fontWeight: 600, color: "#555" }}>To Date</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{ height: "36px", padding: "0 8px", borderRadius: "4px", border: "1px solid #ced4da", fontSize: "14px" }}
                  />
                </div>

                <button
                  onClick={handleClearFilters}
                  style={{ height: "36px", padding: "0 18px", borderRadius: "4px", border: "none", backgroundColor: "var(--color-primary)", color: "#fff", fontWeight: 600, fontSize: "14px", cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  Clear
                </button>
              </div>

              <div className="cashless_balance_report-table-responsive">
                <table className="cashless_balance_report-table">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>#</th>
                      <th style={{ textAlign: "center" }}>Payment For</th>
                      <th style={{ textAlign: "center" }}>class name</th>
                      <th style={{ textAlign: "center" }}>Mode</th>
                      <th style={{ textAlign: "center" }}>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan="4"
                          style={{ textAlign: "center", padding: "7px" }}
                        >
                          <div className="text-center">
                            <ScaleLoader color="#F4BB44" />
                          </div>
                        </td>
                      </tr>
                    ) : reportData.length > 0 ? (
                      reportData.map((item, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.transaction_payment_for?.toUpperCase()}
                          </td> 
                           <td style={{ textAlign: "center" }}>
                            {item.class_name?.replace("_", " ")}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.transaction_mode?.replace("_", " ")}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                              color: "#2dce89",
                            }}
                          >
                            {customer_currency} {formatNumber(item.sum)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="4"
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          No records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Collection_Report;
